import React from 'react';

const COLORS = [
  { id: 'gray', label: 'Grau', hex: '#f4f4f4', border: '#999' },
  { id: 'white', label: 'Weiß', hex: '#ffffff', border: '#999' },
  { id: 'blue', label: 'Blau', hex: '#00859b', border: '#00859b' },
  { id: 'yellow', label: 'Gelb', hex: '#e8a817', border: '#e8a817' },
  { id: 'purple', label: 'Lila', hex: '#82378c', border: '#82378c' },
];

const ColorSelectWidget = ({ id, value, onChange }) => {
  const current = value || 'gray';

  return (
    <div
      className="fcmh-color-widget"
      role="radiogroup"
      aria-label="Hintergrundfarbe"
    >
      {COLORS.map((c) => {
        const active = current === c.id;
        return (
          <button
            key={c.id}
            type="button"
            role="radio"
            aria-checked={active}
            aria-label={c.label}
            className={`fcmh-color-widget__option${active ? ' is-active' : ''}`}
            style={{
              backgroundColor: c.hex,
              borderColor: active ? '#d00' : c.border,
            }}
            onClick={() => onChange(id, c.id)}
            title={c.label}
          >
            {active && <span className="fcmh-color-widget__dot" />}
          </button>
        );
      })}
    </div>
  );
};

export default ColorSelectWidget;
